const Footer = () => {
  return (
    <footer className="w-full mt-12 px-5 md:px-10 pb-8">
      <div className="page-panel mx-auto max-w-6xl rounded-[1.8rem] px-6 py-5 text-center">
        <p className="text-sm text-[color:var(--text-soft)]">
          © {new Date().getFullYear()} Amr El Shimy. Crafted with precision and
          purpose.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
